import axios from 'axios'
import endpoints from '@/api/endpoints'

export default {
  async getIrrigationSystemsReport (filter) {
    // C ==> Commericial only
    // R ==> Residential only
    return axios.get(endpoints.irrigationSystemsReport + '?query_type=' + filter).then((response) => {
      return response.data
    })
  }

  //   if (filter === 'F') {
  //     // F ==> has conflicts. Get all systems with conflicts
  //     return axios.get(endpoints.irrigationSystemsReport + '?query_type=' + filter).then((response) => {
  //       return response.data
  //     })
  //   } else if (filter === 'R') {
  //     return axios.get(endpoints.irrigationSystemsReport + '?query_type=' + ).then((response) => {
  //       return response.data
  //     })
  //   } else if (filter === 'C') {
  //     return axios.get(endpoints.irrigationSystemsReport + '?is_comm=true').then((response) => {
  //       return response.data
  //     })
  //   }
  //   return axios.get(endpoints.irrigationSystemsReport).then((response) => {
  //     return response.data
  //   })
  // }
}
